import * as Sentry from '@sentry/vue'
import { useBrowserInfo } from '@/composables/useBrowserInfo'
import type { FeedbackPayload } from '@/entities/FeedbackPayload.ts'
import type { Feedback } from '@/entities/Feedback.ts'
import { BaseService } from '@/services/BaseService.ts'
import { useAuthStore } from '@/store/auth.ts'

class FeedbackService extends BaseService {
  async submitFeedback(payload: FeedbackPayload): Promise<Feedback> {
    const { browserInfo } = useBrowserInfo()
    const user = useAuthStore().user
    
    const fullFeedback: Feedback = {
      message: payload.feedback,
      otherInfo: {
        ...browserInfo.value.otherInfo,
        category: payload.category,
      },
    }

    Sentry.captureFeedback(
      { 
        message: payload.feedback,
        name: user?.name || 'Unknown User',
        email: user?.username || 'unknown@novonordisk.com', 
      },
      {
        captureContext: {
          tags: { key: payload.category },
        }
      }
    )
    const { data } = await this.instance.post<Feedback>('/api/user-info/feedback', fullFeedback)
    return data
  }
}

export const feedbackService = new FeedbackService()
